import React, { useState, useEffect } from 'react';
import { Popover, Box, TextField, Button } from '@material-ui/core';
import Select from 'react-select';
import Typography from '@material-ui/core/Typography';

const CenteredPopover = ({
  open,
  onClose,
  title = 'Seleziona e Inserisci',
  description = '',
  selectOptions = [],
  defaultSelectValue = null,
  defaultInputValue = '',
  nameText = 'Nome',
  onConfirm
}) => {
  const [selectedOption, setSelectedOption] = useState(defaultSelectValue);
  const [inputValue, setInputValue] = useState(defaultInputValue);

  const handleConfirm = () => {
    if (onConfirm) onConfirm({ selectedOption, inputValue });
    onClose();
  };

    useEffect(() => {
    setSelectedOption(defaultSelectValue);
    setInputValue(defaultInputValue);
  }, [defaultSelectValue, defaultInputValue]);

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorReference="none" // ignora anchorEl
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      container={document.body} 
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
      PaperProps={{
        style: {
          padding: '24px',
          maxWidth: '300px',
          width: '100%',
          margin: 'auto', 
          position: 'relative',
        },
      }}
    >
      <Box>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="textSecondary" style={{ marginBottom: '12px' }}>
            {description}
          </Typography>
        )}

        {/* Select */}
        <Box style={{ marginBottom: '16px' }}>
          <Select
            value={selectedOption}
            onChange={(value) => setSelectedOption(value)}
            options={selectOptions}
            isClearable
            placeholder="Seleziona un valore"
          />
        </Box>

        {/* Input Text */}
        <TextField
          required
          label={nameText}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          fullWidth
          margin="normal"
        />

        {/* Button conferma */}
        <Box style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end' }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleConfirm}
          >
            Salva
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default CenteredPopover;
